import { Component, OnInit, ViewChild } from '@angular/core';
import {Location} from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestReponse } from '../../requets/shared/model/request-reponse.model';
import { RequestService } from '../../requets/shared/request.service';
import { DetailRequest } from '../../requets/shared/model/detail-request.model';
import { College } from '../../requets/shared/model/college.model';
import { DetailRequestComponent } from '../../requets/detail-request/detail-request.component';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { SelectEvaluatorDialogComponent } from 'src/app/core/modal/select-evaluator-dialog/select-evaluator-dialog.component';
import { AssesmentsService } from '../shared/assesments.service';
import { AssigmentEvaluatorSubject } from '../shared/assigment-evaluator-subject.model';
import { HistoryStudentDialogComponent } from '../../../core/modal/history-student-dialog/history-student-dialog.component';
import { StudentService } from '../../students/shared/student.service';
import { ConfirmationDialogComponent } from '../../../core/modal/confirmation-dialog/confirmation-dialog.component';
import { SaveDescriptionDialogComponent } from '../../../core/modal/save-description-dialog/save-description-dialog.component';
import { DenyRequest } from '../../requets/shared/model/deny-request';
import { DetailRequestPorficienceComponent } from '../../requets/detail-request-porficience/detail-request-porficience.component';
import { SelectPeriodDialogComponent } from '../select-period-dialog/select-period-dialog.component';
import { SendEvaluationPifle } from '../shared/send-evaluation-pifle.model';


@Component({
  selector: 'app-assign-single-evaluator',
  templateUrl: './assign-single-evaluator.component.html',
  styleUrls: ['./assign-single-evaluator.component.scss']
})
export class AssignSingleEvaluatorComponent implements OnInit {

  request: RequestReponse;
  detailRequest:  DetailRequest[];
  colleges: College[];
  messageError: String = '';
  claseMessage: String = 'messaje-error';
  enabledSpinner = false;
  isPifle = false;
  isEvalutaion = false;
  interval;
  timeLeft = 4;
  idc: Number;

  @ViewChild(DetailRequestComponent) detailRequestComponent;
  @ViewChild(DetailRequestPorficienceComponent) detailRequestPorficienceComponent;


  constructor(private route: ActivatedRoute,
              private dialog: MatDialog,
              private location: Location,
              private assesmentsService: AssesmentsService,
              private studentService: StudentService,
              private requestService: RequestService,
              private router: Router) {
    this.route.queryParams.subscribe(
      (params) => {
        this.request = JSON.parse(params['request']);
        const validation = params['isEvaluation'] === 'true';
        this.isEvalutaion = validation;
        this.isPifle = this.request.solicitud.tipo === 'PRUEBA LENGUA EXTRANJERA';
        this.getColleges();
      }
    );

  }

  ngOnInit() {
  }
  approve() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { tittle: 'Mensaje Confirmación', message: 'Señor evaluador, al guardar '
    + ' este reconocimiento, la(s) prueba(s) presentada(s) por el estudiante pemitirán que se '
    + 'le reconozcan los 5 niveles de inglés del programa PIFLE. Está seguro?'};
    dialogConfig.width = '30%';
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
        if (value === 1) {
          this.showDialogPeriod();
        }
    });
  }

  back() {
     this.location.back();
     if (this.interval !== undefined) {
      clearInterval(this.interval);
     }
  }

  deny() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { tittle: 'Mensaje Confirmación', message: '¿Esta seguro que desea Rechazar las materias?'};
    dialogConfig.width = '40%';
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
        if (value === 1) {
          this.openDilogDeny();
        }
    });
  }

  getCollegeText(idCollege) {
    this.idc = Number(idCollege);
    if (this.colleges) {
      const college = this.colleges.find(
        (item) =>  item.codigo === this.idc
     );
     if (college === undefined) {
       return 'UNIVERSIDAD DE ANTIOQUIA';
     } else {
       return college.nombre;
     }
    }
   }

   openDialogEvaluator() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { tittle: 'Seleccionar evaluador' };
    dialogConfig.width = '70%';
    const dialogRef = this.dialog.open(SelectEvaluatorDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
      if (value !== null) {
          const evaluator = value.item.numeroIdentificacion + ' | ' + value.item.nombres;
          this.detailRequestComponent.setEvalutors(evaluator);
      }
    });
   }

  sendEvaluators() {
    this.messageError = '';
    if (this.detailRequestComponent) {
     const assigmentsSubject = this.generateSubjectWithEvaluator();
      if (assigmentsSubject.length > 0) {
        this.enabledSpinner = true;
        this.assesmentsService.sendEvaluatorBySubject(assigmentsSubject).subscribe(
          (result) => {
            this.enabledSpinner = false;
            if (result.data) {
                if (result.data === 'OK') {
                  this.claseMessage = 'messaje-success';
                  this.messageError = 'Se asignó correctamente el docente';
                  this.getColleges();
                } else {
                  this.messageError = result.data ;
                }
            }
          }
        );
      } else {
        this.messageError = 'Se debe asignar por lo menos  un evaluador a una Asignatura';
      }
    }
  }

  generateSubjectWithEvaluator() {
    return this.detailRequestComponent.detailRequest.filter(
      (detail: DetailRequest) => detail.evaluador
     ).map(
        (detail: DetailRequest) => {
          if (detail.evaluador) {
            const assigmentSubject = new AssigmentEvaluatorSubject();
            assigmentSubject.solicitud = detail.id.solicitud;
            assigmentSubject.consecutivo = detail.id.consecutivo;
            const evaluadorData = detail.evaluador.split('|');
            assigmentSubject.cedula = evaluadorData[0].trim();
            return assigmentSubject;
          }
        }
      );
  }

  showHistory() {
    this.studentService.getStudentRecords(this.request.solicitud.cedula , this.request.programa.codigo, true).subscribe(
      (result) => {
        if (result.data) {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.data =  { semestres: result.data.semestres.sort() , historia: result.data.historia,
                                  cedula: this.request.solicitud.cedula , nombre : this.request.nombreEstudiante,
                                  programa: this.request.programa.nombre};
          dialogConfig.width = '70%';
          this.dialog.open(HistoryStudentDialogComponent, dialogConfig);
        }
      }
    );
  }

  validateLoadData(): boolean {
    return (!this.colleges &&  !this.detailRequest);
  }

  validateSeletion(): boolean {
    if (this.isPifle) {
      if (this.detailRequestPorficienceComponent) {
        if (this.detailRequestPorficienceComponent.selection.selected.length > 0) {
          return false;
        }
      }
    } else {
      if (this.detailRequestComponent) {
        if (this.detailRequestComponent.selection.selected.length > 0) {
          return false;
        }
      }
    }
    return true;
  }

  private getColleges() {
    // this.enabledSpinner = true;
    this.requestService.getColleges().subscribe(
      (result) => {
        if (result.data) {
          this.colleges = result.data as College[];
          this.getDetailRequest();
        }
      }
    );
  }

  private getDetailRequest() {
    // this.messageError = '';
    const type =  this.isPifle ? 10 : 1;
      this.requestService.getDetailRequets(this.request.solicitud.solicitud, type, null, 'I').subscribe(
        (result) => {
            if (result.data) {

              if (result.data.length > 0) {
                this.enabledSpinner = false;
                this.detailRequest = result.data as DetailRequest[];
                if (!this.isPifle) {
                  this.detailRequest = this.detailRequest.map(
                    (detail) => {
                        detail.nombreinstitucion = this.getCollegeText(detail.institucion);
                        return detail;
                    }
                  );
                }

              } else {
                // this.back();
                this.startTimer();
              }
            }
        }
      );
  }

  private openDilogDeny() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { tittle: 'RECHAZAR SOLICITUD DE RECONOCIMIENTO', filedName: 'Justificación' };
    dialogConfig.width = '50%';
    const dialogRef = this.dialog.open(SaveDescriptionDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
      if (value !== null) {
          const deny = new DenyRequest();
          deny.solicitud = this.request.solicitud.solicitud;
          deny.justificacion = value;
          if (this.isPifle) {
            deny.consecutivos = this.detailRequestPorficienceComponent.selection.selected.map(
              (detail: DetailRequest) => detail.id.consecutivo
            );
          } else {
            deny.consecutivos = this.detailRequestComponent.selection.selected.map(
              (detail: DetailRequest) => detail.id.consecutivo
            );
          }
          this.enabledSpinner = true;
          this.requestService.denyRequets(deny).subscribe(
            (result) => {
              if (result.data) {
                this.enabledSpinner = false;
                if (result.data === 'OK') {
                  this.claseMessage = 'messaje-success';
                  this.messageError = 'Se rechazaron las solicitudes seleccionadas ';
                  this.getColleges();
                } else {
                  this.claseMessage = 'messaje-error';
                  this.messageError = result.data;
                }
              }
            }
          );
      }
    });
  }

  private showDialogPeriod() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { };
    dialogConfig.width = '31%';
    const dialogRef = this.dialog.open(SelectPeriodDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
        if (value !== null) {
          const periodo = value.period as String;
          const evaluation =  new SendEvaluationPifle();
          evaluation.consecutivo = this.detailRequestPorficienceComponent.detailRequest[0];
          evaluation.nota = '7.7';
          evaluation.periodo =  periodo.replace('-', '');
          evaluation.programa = this.request.programa.codigo;
          evaluation.version = this.request.programa.version;
          let comentario = '';
          this.detailRequestPorficienceComponent.detailRequest.forEach( (element: DetailRequest) => {
            comentario = comentario + ' - ' + element.regiPruebasEstandarIdioma.nombre;
          });
          evaluation.comentario = comentario;
          this.enabledSpinner = true;
          this.assesmentsService.savedEvaluationPifle(evaluation).subscribe(
            (result) => {
              this.enabledSpinner = false;
                if (result.data) {
                  const data = result.data as String;
                  if (data.trim().length > 0) {
                      this.messageError = data;
                      this.claseMessage = 'messaje-error';
                  } else {
                    this.claseMessage = 'messaje-success';
                    this.messageError = 'Se aprobo el reconocimiento';
                    this.startTimer();
                  }
                }
            }
          );
        }
    });
  }

  private startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
         this.back();
      }
    }, 1000);

  }

}
